import angular from 'angular';
import { ModalComponent } from './modal.component';
import './modal.scss';

export * from './modal.component';

export default angular.module('spa.core.components.modal', [

])
  .component(ModalComponent.selector, ModalComponent)
  .name;


// WEBPACK FOOTER //
// ./src/core/components/modal/index.js